import type {
  ProjectProfitTableDataQuery,
  ProjectRevenueOrderByColumnEnum,
  ProjectRevenueTableDataQuery,
  SortOrder,
} from "@src/__generated__/urql-graphql";
import type { BodyColumnDef, BodyRow } from "@src/components/ui-kit";
import type { ProjectProfitModel } from "../profit/models";
import type { ProjectRevenueModel } from "../revenue/models";

export type TProject = NonNullable<
  | ProjectRevenueTableDataQuery["projectRevenue"]
  | ProjectProfitTableDataQuery["projectRevenue"]
>["projects"][0];

export type DetailSummary = {
  billings: number;
  netProfit: number;
  netMargin: number;
};

export type ProjectReportRow = BodyRow &
  (ProjectProfitModel | ProjectRevenueModel);

export type ProjectReportColumn<Row extends BodyRow = ProjectReportRow> =
  BodyColumnDef<Row, ProjectRevenueOrderByColumnEnum>;

export type ProjectReportDetailClick = (
  projectId: ProjectProfitModel["id"],
  grossIncome: ProjectProfitModel["gross_income_for_date_range"],
) => void;

export type ProjectReportOrderByClause = {
  column: ProjectRevenueOrderByColumnEnum;
  order: SortOrder;
};

export enum QuickFilter {
  Active = "active",
  Finished = "finished",
  Archived = "archived",
}

export type CategoryName = string;
